export const baseUrl = 'https://dashboard.onyxen-regalia.com/backend/api/admin' 

